// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vs__dropdown-menu{width:0}.vs__dropdown-menu *{overflow-x:hidden;text-overflow:ellipsis}.select-principal-tooltip{max-width:580px;word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
